/**
 * L6 — prefixos de busca no servidor (array-contains).
 * Compartilhado: script de padronização + painel (L6.3).
 */

const MAX_PREFIX_LEN = 15;
const MIN_PREFIX_LEN = 2;
const MAX_PALAVRAS = 60;

/** Minúsculas sem acento. */
export function foldNome(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
}

/** Extrai texto de name (string ou MultiLang). */
export function nomeProdutoTexto(name: unknown): string {
  if (typeof name === 'string') return name;
  if (name && typeof name === 'object') {
    const o = name as { pt?: string; en?: string; es?: string };
    return o.pt || o.en || o.es || '';
  }
  return '';
}

/**
 * Prefixos de 2–15 letras por palavra do nome, sem acento, sem repetição.
 * Limite: 60 itens.
 * Ex.: "Copo Plástico" → ["co","cop","copo","pl","pla",...,"plastico"]
 */
export function gerarPalavrasBusca(nome: string): string[] {
  const folded = foldNome(nome);
  if (!folded) return [];

  const words = folded
    .split(/[^a-z0-9]+/)
    .map((w) => w.replace(/[^a-z0-9]/g, ''))
    .filter((w) => w.length >= MIN_PREFIX_LEN);

  const out: string[] = [];
  const seen = new Set<string>();

  for (const word of words) {
    const max = Math.min(word.length, MAX_PREFIX_LEN);
    for (let len = MIN_PREFIX_LEN; len <= max; len++) {
      const prefix = word.slice(0, len);
      if (seen.has(prefix)) continue;
      seen.add(prefix);
      out.push(prefix);
      if (out.length >= MAX_PALAVRAS) return out;
    }
  }

  return out;
}

export function gerarNomeLower(nome: string): string {
  return foldNome(nome);
}
